<template>
  <div class="sku-list">
    <div class="line">
      <div class="lf">
        <vs-input class="input-item" placeholder="请输入商品69码、名称" v-model="goodsName" />
        <vs-button type="border" color="primary" icon-pack="feather" class="search" @click="searchGoods">查询</vs-button>
        <!-- <template>
          <div class="marLeft-10">订单币种：</div>
          <v-select
            id="currencySelect"
            :options="currencyTypeList"
            v-model="currencyType"
            :reduce="(opt) => opt.id"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            placeholder="请选择订单币种"
          />
        </template> -->
      </div>
    </div>
    <vs-table :data="orderGoodsList" noDataText="暂无数据">
      <template slot="thead">
        <vs-th :class="headData.thClass ? headData.thClass : ''" v-for="(headData, index) in headData" :key="index">{{
          headData.name }}</vs-th>
      </template>
      <template slot-scope="{ data }">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data"
          :class="tr.num <= (tr.availableAmount | 0) ? '' : 'amount-red'">
          <vs-td :data="tr.goodsCategoryName" style="width: 120px"><span v-show="tr.hunitPrice == 0"
              style="color: red">(赠)</span>
            {{ tr.goodsCategoryName }}</vs-td>
          <vs-td :data="tr.skuName" style="width: 260px">{{
            tr.skuName
            }}</vs-td>
          <vs-td :data="tr.skuCode" style="width: 160px">{{
            tr.skuCode
            }}</vs-td>
          <vs-td :data="tr.barCode" style="width: 180px">{{
            tr.barCode
            }}</vs-td>
          <vs-td :data="tr.originOrderNo" style="width: 180px">{{
            tr.originOrderNo
            }}</vs-td>
          <vs-td :data="tr.num" class="modify" style="width: 120px">
            <template v-if="tr.editFlag">
              <gc-cmp-vs-input v-model="tr.num" class="table-edit-input" type="number"
                @change="hunpriceChange(tr, indextr)" />
            </template>
            <template v-else>{{
              tr.num > 0 ? tr.num + tr.unit : 0 + tr.unit
              }}</template>
          </vs-td>
          <vs-td style="width: 120px">{{ tr.sendSpecNum }}</vs-td>
          <vs-td :data="tr.untilPrice" class="text-right" style="width: 80px">{{
            tr.untilPrice | currencyFormat(2, true)
            }}</vs-td>
          <vs-td :data="tr.hunitPrice" class="modify text-right" style="width: 100px">
            <template v-if="
                tr.editFlag &&
                (((billSource == 'HEADER_MAN' ||
                  billSource == 'HEADER_MAN_IMPORT') &&
                  amountInfo.dealTotalPrice != amountInfo.actualTotalPrice) ||
                  amountInfo.dealTotalPrice == 0)
              ">
              <gc-cmp-vs-input v-model="tr.hunitPrice" class="table-edit-input" @change="hunpriceChange(tr, indextr)"
                type="number" />
            </template>
            <template v-else>{{
              (tr.hunitPrice > 0 ? tr.hunitPrice : 0) | currencyFormat(2, true)
              }}</template>
          </vs-td>
          <vs-td :data="tr.itemPrice" class="text-right" style="width: 160px">{{
            tr.itemPrice | currencyFormat(2, true)
            }}</vs-td>
          <vs-td :data="tr.hitemPrice" class="text-right" style="width: 160px">{{ tr.hitemPrice | currencyFormat(2,
            true) }}</vs-td>

          <vs-td :data="tr.actualAmount" class="text-center" style="width: 120px">{{ tr.availableAmount || 0 }}</vs-td>
          <!-- 发货仓/快递单号 -->
          <vs-td :data="tr.sendWs" style="width: 120px">{{ sendWs }}</vs-td>
          <vs-td style="width: 120px">
            <div v-if="
                billSendBo &&
                (billSendBo.expressProvider != '' || billSendBo.expressNo != '')
              ">
              <div>
                {{ billSendBo.expressProvider }}
              </div>
              <div>
                {{ billSendBo.expressNo }}
              </div>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <div class="amount-wrap">
      <div class="alignCenter" v-if="orderGoodsList.length">
        <span>币种</span>
        <span class="amount-value">{{ currencyShow }}</span>
      </div>
      <div class="alignCenter">
        <span>成交总金额</span>
        <span class="amount-value">{{
          amountInfo.dealTotalPrice | currencyFormat(2, false, currencySymbol)
          }}</span>
      </div>

      <div class="alignCenter marTop5">
        <span>原价总金额</span>
        <span class="amount-value">{{
          amountInfo.originalTotalPrice
          | currencyFormat(2, false, currencySymbol)
          }}</span>
      </div>

      <div class="alignCenter marTop5">
        <span>实付总金额</span>
        <span class="amount-value">{{
          amountInfo.actualTotalPrice | currencyFormat(2, false, currencySymbol)
          }}</span>
      </div>

      <div class="alignCenter marTop5">
        <span>折扣总金额</span>
        <span class="amount-value">{{
          amountInfo.discountTotalPrice
          | currencyFormat(2, false, currencySymbol)
          }}</span>
      </div>
    </div>
  </div>
</template>

<script>
  import flatPickr from "vue-flatpickr-component";
  import "flatpickr/dist/flatpickr.css";
  import { Mandarin } from "flatpickr/dist/l10n/zh.js";
  import { OrderGoodsApi } from '@/modules/server-api/commodity-sys/order-goods';
  import { OrderApi } from "@/modules/server-api/commodity-sys/order";
  import vSelect from "vue-select";
  import GcCmpVsInput from "@/group-cloud/components/vsInput";
  import {
    getThreeCategory,
    $busErrorCode,
  } from "@/modules/commodity-sys/common.js";
  export default {
    props: {
      skuData: {
        type: Array,
        default: null,
      },

      orderNo: {
        type: String,
        default: "",
      },

      editFlag: {
        type: [Boolean, String],
        default: false,
      },
      //是否是新增的订单
      newOrder: {
        type: Boolean,
        default: false,
      },
      buyer: {
        type: [String, Number],
        default: null,
      },
      payTypeList: {
        type: Array,
        default: () => {
          return [];
        },
      },
      billSource: {
        type: String,
        default: "",
      },
    },

    data() {
      return {
        orderGoodsList: [],
        isShowPayType: false, //添加新的支付弹框
        isShowUpdateForm: false,
        goodsData: [],
        goodsListSelect: [],
        goodsPriceSelect: [],
        goodsName: "",
        billSendBo: {},
        currencySymbol: "", //订单币种
        currencyType: "RMB",
        currencyShow: "RMB",
        currencyTypeList: [
          { id: "RMB", label: "RMB", symbol: "￥" },
          { id: "USD", label: "USD", symbol: "$" },
        ],
        // headData: ['SKU编码', '69码', '商品名称', '类别', '数量', '原价', '成交价', '原价金额', '成交金额', '可用库存','操作'],
        headData: [
          {
            name: "类别",
          },
          {
            name: "商品名称",
          },
          {
            name: "sku编码",
          },
          {
            name: "69码",
          },
          {
            name: "初始单号",
          },
          {
            name: "下单数量",
          },
          {
            name: "发货数量",
          },
          {
            name: "原价",
            thClass: "text-right",
          },
          {
            name: "成交价",
            thClass: "text-right",
          },
          {
            name: "原价金额",
            thClass: "text-right",
          },
          {
            name: "成交金额",
            thClass: "text-right",
          },
          {
            name: "可用库存",
          },
          {
            name: "发货仓",
          },
          {
            name: "快递/物流",
          },
        ],
        payData: {
          orderNo: "",
          payRecord: {
            payType: "",
            payTypeName: "",
            payTime: "",
            payNo: "",
            payPrice: "",
          },
        },
        payList: [], //支付方式列表
        flatPickerConfig: {
          locale: Mandarin, //日期控件中文
        },
        suggest: "", //搜索框
        categoryIdList: "", //商品分类
        categoryList: [], //商品分类
        goodsList: [], //商品列表
        goodsNum: [], //商品数量
        searchGoodsList: [], //筛选的商品
        pager: {
          page: 1,
          size: 20,
          total: 0,
        },
        amountInfo: {
          actualTotalPrice: 0, //实付总金额
          dealTotalPrice: 0, //成交总金额
          originalTotalPrice: 0, //原价总金额
          discountTotalPrice: 0, //折扣总金额
        }, //价格信息
        addPayList: [], //新增的支付信息,
        editGoodsInfo: {}, //当前修改商品信息
        modifyNum: [],
        modifyPrice: [],
        sendWs: "", //发货仓
        express: "", //快递/物流单号
        selectOldList: [], //存储已经存在的问题
        uid: 0, //配置当前订单商品id
        orderTypeEdit: "", //订单类型   order订货单  invoice发货单
        goodId: "", //换货商品id
        isReplacePopup: false, //换货弹窗
        replaceOrderList: [], //换货列表
        replaceGoodsId: [], //当前换货id
      };
    },

    filters: {
      formatPrice(value) {
        // console.log('formatPrice',value)
        if (value) {
          return Number(Number(value).toFixed(2));
        }
        return "0.00";
      },
    },
    mounted() {
      // this.$nextTick(() => {
      //   this.orderGoodsList=this.skuData
      //   this.computeTotalPrice(this.orderGoodsList)
      // });
    },
    methods: {
      // 阻止滚动条滚动
      stopScroll() {
        document.body.style.top = "0";
        document.body.style.position = "fixed";
        document.body.style.height = "100%";
        document.body.style.overflow = "hidden";
      },
      // 恢复滚动条滚动
      autoScroll() {
        document.body.style.position = "initial";
        document.body.style.overflowY = "auto";
      },

      //格式化金额
      formatPrice(price, fixedNum) {
        price = Number(price);
        fixedNum = fixedNum || 2;
        if (price > 0) {
          return parseFloat(price).toFixed(fixedNum);
        } else {
          return "";
        }
      },

      //筛选商品:只保留skuCode, skuName, barcode
      searchGoods() {
        let self = this;
        console.log(this.goodsName);
        //   &&this.goodsName.split(" ").join("").length!=0
        if (this.goodsName.trim() != "") {
          console.log("=====================111")
          this.orderGoodsList = this.searchGoodsList.filter((item, index) => {
            if (
              (item.skuCode && item.skuCode.indexOf(self.goodsName.trim()) > -1) ||
              (item.skuName && item.skuName.indexOf(self.goodsName.trim()) > -1) ||
              (item.barCode && item.barCode.indexOf(self.goodsName.trim()) > -1)
            ) {
              return item;
            }
          });


        } else {
          this.orderGoodsList = this.searchGoodsList;

        }
        this.computeTotalPrice(this.orderGoodsList)
      },

      //获取该订单关联的商品
      async getOrderGoodsList() {
        // let orderTypeEdit = sessionStorage.getItem("orderTypeEdit") || 'order';
        // console.log(orderTypeEdit)
        let orderGoodsList = [];
        // if(orderTypeEdit == 'order'){
        //   orderGoodsList = await OrderApi.getNewOrderGoods({orderNo: this.orderNo, goodLoc: 1});
        // }else{
        orderGoodsList = await OrderApi.getOrderGoods({ orderNo: this.orderNo, goodLoc: 1 });
        // }
        this.orderGoodsList = orderGoodsList.result.skuItems;
        if (this.orderGoodsList.length) {
          //获取币种
          let currency = this.orderGoodsList[0].currency || this.currencyTypeList[0].id;
          const cIndex = this.currencyTypeList.findIndex(item => item.id == currency);
          this.currencySymbol = this.currencyTypeList[cIndex].symbol;
          this.currencyShow = this.currencyTypeList[cIndex].id;

          this.orderGoodsList = this.orderGoodsList.map((item, index) => {
            this.$set(item, "editFlag", false)
            //格式化金额
            item.hunitPrice = this.formatPrice(item.hunitPrice);
            item.untilPrice = this.formatPrice(item.untilPrice);
            item.itemPrice = this.formatPrice(item.itemPrice);
            item.hitemPrice = this.formatPrice(item.hitemPrice);
            item.offerFlag = item.orderType == '1' ? true : false;
            return item;
          })
        }
        console.log(this.orderGoodsList)
        //获取物流单号及发货仓
        this.sendWs = orderGoodsList.result.sendWs;
        this.express = orderGoodsList.result.express;
        this.billSendBo = orderGoodsList.result.billSendBo;
        sessionStorage.setItem("updateSkuItemList", JSON.stringify(this.orderGoodsList));
        this.searchGoodsList = this.orderGoodsList;
        this.amountInfo = orderGoodsList.result;
        let addPayList = orderGoodsList.result.payRecords;
        let sellerRemark = orderGoodsList.result.sellerRemark;
        let receiveInfo = { receiveName: orderGoodsList.result.receiveName, receivePhone: orderGoodsList.result.receivePhone, address: orderGoodsList.result.address };
        this.$emit("getAddPayList", addPayList);
        this.$emit("getSellerRemark", sellerRemark);
        this.$emit("getReceiveInfo", receiveInfo);
        this.$emit("getAmountInfo", this.amountInfo);
      },

      //计算金额
      computeTotalPrice(list) {
        console.log(list,"重新计算金额");
        //计算总金额
        this.amountInfo.dealTotalPrice = 0;
        this.amountInfo.originalTotalPrice = 0;
        this.amountInfo.discountTotalPrice = 0;
        this.amountInfo.actualTotalPrice = 0;
        list = list.map((item, index) => {
          console.log("item", item);
          //原价金额和成交 hunitPrice
          item.itemPrice = Number(item.untilPrice) * Number(item.num);
          item.hitemPrice = Number(item.hunitPrice) * Number(item.num);
          // 成交总金额
          this.amountInfo.dealTotalPrice += Number(item.hitemPrice);
          //原价总金额
          this.amountInfo.originalTotalPrice += Number(item.itemPrice);
          return item;
        });
        console.log( this.amountInfo.dealTotalPrice,"成交金额",this.amountInfo.originalTotalPrice,"原价金额")
        this.amountInfo.dealTotalPrice = Number(
          this.amountInfo.dealTotalPrice.toFixed(2)
        );
        this.amountInfo.originalTotalPrice = Number(
          this.amountInfo.originalTotalPrice.toFixed(2)
        );
        // 折扣总金额
        this.amountInfo.discountTotalPrice = Number(
          Number(
            this.amountInfo.originalTotalPrice - this.amountInfo.actualTotalPrice
          ).toFixed(2)
        );
        // console.log("折扣总金额===", this.amountInfo.discountTotalPrice);
        sessionStorage.setItem("updateSkuItemList", JSON.stringify(list));
      },
    },

    watch: {
      orderNo: {
        handler(newVal, oldVal) {
          if (newVal) {
            console.log("==========newVal", newVal)
            this.getOrderGoodsList()
          }
        },
        immediate: true
      },
      currencyType(val) {
        console.log("订单币种：===", val);
        const cIndex = this.currencyTypeList.findIndex((item) => item.id == val);
        this.currencySymbol = this.currencyTypeList[cIndex].symbol;
        this.currencyShow = val;
      },
      //更新币种
      currencySymbol() {
        this.$emit("updateCurrency", this.currencySymbol);
      },
    },

    components: {
      flatPickr,
      "v-select": vSelect,
      GcCmpVsInput,
    },
  };
</script>

<style>
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  input[type="number"] {
    -moz-appearance: textfield;
  }

  .new-goods-pop .vs-table--content {
    height: 400px !important;
  }
</style>

<style lang="scss" scoped>
  @import "@/modules/commodity-sys/commodity.scss";

  @mixin flex-mixin($direction, $align, $justify) {
    display: flex;
    flex-direction: $direction;
    align-items: $align;
    justify-content: $justify;
  }

  .flatpickr-calendar.open {
    z-index: 9999999;
  }

  .sku-list {
    width: 100%;

    .line {
      @include flex-mixin(row, center, space-between);
      margin-bottom: 6px;

      .lf {
        @include flex-mixin(row, center, flex-start);

        .search {
          margin-left: 10px;
        }

        /deep/ .vs-button {
          padding: 8px 25px !important;
        }
      }

      .btn {
        margin-left: 10px;
      }
    }

    .a_btn {
      //display: inline-block;
      padding: 0 !important;
      margin-right: 12px;
    }

    /deep/ .vs-con-tbody {
      max-height: 300px;
      overflow: auto;
    }
  }

  .goods-popup /deep/ .vs-popup {
    width: 1100px;
  }

  /deep/ .new-goods-pop {
    min-height: 500px;

    .category-select {
      width: 300px;
    }
  }

  .amount-wrap {
    text-align: right;
    margin-top: 20px;

    .amount-value {
      // min-width: 6%;
      display: inline-block;
      text-align: left;
    }

    span {
      margin-right: 10px;
    }
  }

  .modify /deep/ span {
    display: inline-block;
    align-items: center;
  }

  .text-primary {
    margin-left: 10px;
    cursor: pointer;
  }

  .pay-wrap {
    padding-bottom: 40px;

    h1 {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 10px;
    }

    .pay-info {
      display: flex;
      align-items: center;

      div {
        width: 14%;
        margin-left: 30px;

        span {
          margin-right: 10px;
        }
      }
    }
  }

  #currencySelect.v-select {
    width: 150px;
  }

  .marLeft-10 {
    margin-left: 10px;
  }

  .amount-red {
    color: #f56c6c;
  }
</style>